import { apiClient } from './client';
import type { MatchCustomer } from '@/lib/helpdesk/matchAccounts';

export interface CustomerDirectory {
  customers: MatchCustomer[];
  warning: string | null;
}

/** Cached dashboard customer directory; never waits on Active IQ. */
export async function fetchCustomerDirectory(): Promise<CustomerDirectory> {
  const { data } = await apiClient.get('/dashboard/customers');
  return { customers: data.customers ?? [], warning: data.warning ?? null };
}
